import "./LoaderAlert.css";

const Loader = () => {
  return (
    <div className="boxloaderAlert-lealtad">
      <div className="loaderAlert-lealtad">
        Cargando
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
